export enum OrderTab {
  Details = 'details',
  Epd = 'epd',
}
